// i18n/config.ts
export const LOCALES = ["en", "zh"] as const;
export type AppLocale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export function isValidLocale(locale: string): locale is AppLocale {
  return LOCALES.includes(locale as AppLocale);
}

export function getDefaultLocaleByDomain(host?: string | null): AppLocale {
  if (!host) return DEFAULT_LOCALE;

  const hostname = host
    .replace(/^https?:\/\//, "")
    .split(":")[0]
    .toLowerCase();

  if (hostname === "cn.ppc-tapioca.com") return "zh";

  return DEFAULT_LOCALE;
}
